const CONTRACTS = [
  { name: 'GovernanceToken', symbol: 'EMBER', address: '0x944b0f4016b6A12Fd7aCfdF0BDf5fce4C5B82Ed1' },
  { name: 'Factory', address: '0xF11e9aE42Aa0FF1Dff1Bb5A621C49ae74DD81909' },
  { name: 'Router', address: '0xE52Dc85842DD8d5d8a176D7cC50fD50b64Fbc7a6' },
  { name: 'MasterChef', address: '0x8181C5f53FdEE1AEdEde1D6dE287109dCF0a7614' },
  { name: 'Treasury', address: '0xd6024731Ce7fA057e287ADEA7404aa6edBB3C458' },
  { name: 'WrappedTokenFactory', address: '0xb115458C17536785772Ab93498D20cD776E0f2aB' },
  { name: 'LPRewards', address: '0x4B97b031A2F05B8deFd06001D47AB5FdcE5cf7d4' },
];

const EXPLORER_BASE = 'https://flare-explorer.flare.network/address';

export default function Contracts() {
  const handleCopy = (address) => {
    navigator.clipboard.writeText(address);
  };

  return (
    <div style={{ maxWidth: '760px', margin: '0 auto', padding: '24px 16px' }}>
      <h2 style={{ color: '#A78BFA', fontSize: '1.5rem', marginBottom: '8px' }}>
        Deployed Contracts
      </h2>
      <p style={{ color: '#9ca3af', fontSize: '0.9rem', marginBottom: '24px' }}>
        All contracts are deployed on Flare Mainnet and verified on the block explorer.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {CONTRACTS.map(({ name, symbol, address }) => (
          <div
            key={address}
            style={{
              backgroundColor: '#0f0520',
              border: '1px solid rgba(109, 40, 217, 0.4)',
              borderRadius: '10px',
              padding: '14px 18px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <div>
              <div style={{ color: '#e5e7eb', fontWeight: '600', fontSize: '0.95rem' }}>
                {name}{symbol && <span style={{ color: '#FB923C', marginLeft: '6px', fontWeight: '400' }}>({symbol})</span>}
              </div>
              <div style={{ color: '#9ca3af', fontSize: '0.8rem', marginTop: '4px', fontFamily: 'monospace' }}>
                {address}
              </div>
            </div>

            <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
              <button
                onClick={() => handleCopy(address)}
                title="Copy address"
                style={{
                  background: 'rgba(167,139,250,0.1)',
                  border: '1px solid rgba(167,139,250,0.3)',
                  borderRadius: '6px',
                  color: '#A78BFA',
                  padding: '5px 12px',
                  fontSize: '0.8rem',
                  cursor: 'pointer',
                }}
              >
                Copy
              </button>
              <a
                href={`${EXPLORER_BASE}/${address}#code`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: 'rgba(251,146,60,0.1)',
                  border: '1px solid rgba(251,146,60,0.3)',
                  borderRadius: '6px',
                  color: '#FB923C',
                  padding: '5px 12px',
                  fontSize: '0.8rem',
                  textDecoration: 'none',
                  cursor: 'pointer',
                }}
              >
                Explorer ↗
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
